import { Box, Grid, Paper, Typography } from '@mui/material';
import { useTranslation } from '../hooks/useTranslation';

export const ScoreDescription = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography
        variant="body1"
        sx={{
          fontSize: '0.95rem',
          mb: 2,
          color: 'text.secondary',
        }}
      >
        {t('scoredescription.description')}
      </Typography>

      <Grid container spacing={2}>
        {/* Score baixo */}
        <Grid item xs={12} md={4}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              textAlign: 'center',
              height: '100%',
            }}
          >
            <Typography sx={{ fontSize: '0.95rem', fontWeight: 600 }}>
              {t('scoredescription.lowScore')}
            </Typography>

            <Typography
              sx={{
                fontSize: '1.4rem',
                fontWeight: 700,
                color: 'error.main',
                my: 0.5,
              }}
            >
              0 a 300
            </Typography>

            <Typography sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
              {t('scoredescription.highRiskExplanation')}
            </Typography>
          </Paper>
        </Grid>

        {/* Score médio */}
        <Grid item xs={12} md={4}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              textAlign: 'center',
              height: '100%',
            }}
          >
            <Typography sx={{ fontSize: '0.95rem', fontWeight: 600 }}>
              {t('scoredescription.mediumScore')}
            </Typography>

            <Typography
              sx={{
                fontSize: '1.4rem',
                fontWeight: 700,
                color: 'warning.main',
                my: 0.5,
              }}
            >
              301 a 700
            </Typography>

            <Typography sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
              {t('scoredescription.mediumRiskExplanation')}
            </Typography>
          </Paper>
        </Grid>

        {/* Score alto */}
        <Grid item xs={12} md={4}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              textAlign: 'center',
              height: '100%',
            }}
          >
            <Typography sx={{ fontSize: '0.95rem', fontWeight: 600 }}>
              {t('scoredescription.highScore')}
            </Typography>

            <Typography
              sx={{
                fontSize: '1.4rem',
                fontWeight: 700,
                color: 'success.main',
                my: 0.5,
              }}
            >
              701 a 1000
            </Typography>

            <Typography sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
              {t('scoredescription.lowRiskExplanation')}
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Typography
        sx={{
          mt: 2,
          fontSize: '0.8rem',
          color: 'text.secondary',
          textAlign: 'center',
        }}
      >
        {t('scoredescription.scoreExplainSerasa')}
      </Typography>
    </Box>
  );
};
